import { Icon } from 'components/Icon';
import PropTypes from 'prop-types';
import { theme } from 'ui/theme-color';
import { TabBadge, TabItem, TabsContainer } from './styled';

/**
 * Barra de abas com ícone opcional e contador.
 *
 * @param tabs - [{ id, title, icon, badge, disabled, hint }]
 * @param active - id da aba selecionada
 * @param onChange - recebe o id da aba clicada
 * @param color - cor de destaque (padrão: secundária do tema)
 * @param small - versão compacta
 * @param wrap - quebra em várias linhas em vez de rolar na horizontal
 */
export default function Tabs({ tabs, active, onChange, color, small, wrap }) {
  const destaque = color || theme.palette.secondary.main;

  return (
    <TabsContainer $wrap={wrap}>
      {(tabs || []).map((item) => {
        const selecionada = active === item.id;
        return (
          <TabItem
            key={item.id}
            type="button"
            color={destaque}
            $active={selecionada}
            $small={small}
            disabled={item.disabled}
            title={item.hint}
            onClick={() => !item.disabled && onChange?.(item.id)}
          >
            {item.icon ? (
              <Icon
                name={item.icon}
                size={small ? 18 : 20}
                color={selecionada ? destaque : '#4a5568'}
              />
            ) : null}
            {item.title}
            {item.badge === undefined || item.badge === null ? null : (
              <TabBadge color={destaque} $active={selecionada}>
                {item.badge}
              </TabBadge>
            )}
          </TabItem>
        );
      })}
    </TabsContainer>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      badge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      disabled: PropTypes.bool,
      hint: PropTypes.string,
    })
  ).isRequired,
  active: PropTypes.string,
  onChange: PropTypes.func,
  color: PropTypes.string,
  small: PropTypes.bool,
};
